import {
    createBaseThemeOptions,
    createUnifiedTheme,
    palettes,
} from '@backstage/theme';
import rawlineFonts from './fonts';
import { defaultTypography } from '@backstage/theme';
import { CustomBackstageTheme } from './backstage/customBackstage';
import { CustomSignInPageTheme } from './backstage/customSignInPage';
import { CustomFilters } from './backstage/customFilters';

export const customTheme = createUnifiedTheme({
    defaultPageTheme: 'home',
    fontFamily: 'Rawline',
    components: ({
        MuiCssBaseline: {
            styleOverrides: {
                '@font-face': rawlineFonts,
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                    borderRadius: '100em',
                    fontWeight: '600',
                },
            },
        },
        MuiTableRow: {
            styleOverrides: {
                root: {
                    fontSize: 14
                }
            }
        },
        MuiTableCell: {
            styleOverrides: {
                root: {
                    gap: 8
                }
            }
        },
       ...CustomBackstageTheme,
       ...CustomSignInPageTheme,
       ...CustomFilters
    }) as any,
    ...createBaseThemeOptions({
        palette: {
            ...palettes.light,
            primary: {
                main: '#1351B4',
                light: '#1351B4'
            },
            divider: '#CCCCCC',
            action: {
                active: '#1351B4'
            },
            secondary: {
                main: '#168821',
                light: '#168821'
            },
            error: {
                main: '#E52207',
            },
            warning: {
                main: '#FFCD07',
            },
            info: {
                main: '#1351B4',
            },
            success: {
                main: '#168821',
            },
            background: {
                default: '#F5F7FA',
                paper: '#FFF',
            },
            banner: {
                info: '#1351B4',
                error: '#E52207',
                text: '#000000',
                link: '#1351B4',
            },
            errorBackground: '#E52207',
            warningBackground: '#FFCD07',
            infoBackground: '#000000',
        },
        typography: {
            ...defaultTypography,
            htmlFontSize: 16,
            fontFamily: 'Rawline',
            h1: {
                fontSize: 72,
                fontWeight: 700,
                marginBottom: 10,
                fontFamily: 'Rawline',
            },
        },
    }),
});